import { To } from "react-router";

import { GaiaExpandableMapMarkerHeader } from "~/modules/plannerV2/components/GaiaExpandableMapMarker/GaiaExpandableMapMarkerHeader";

import { AreaCardHeader } from "../AreaCard/AreaCardHeader";
import IconArea from "../IconArea";
import { GaiaExpandableMapMarkerAreaHeaderFragment } from "./fragments.generated";

type GaiaExpandableMapMarkerAreaHeaderProps = {
    area: GaiaExpandableMapMarkerAreaHeaderFragment;
    areaNameHref: (areaId: string) => To;
};

export function GaiaExpandableMapMarkerAreaHeader({ area, areaNameHref }: GaiaExpandableMapMarkerAreaHeaderProps) {
    return (
        <GaiaExpandableMapMarkerHeader>
            <IconArea plannerStatusBucket={area.plannerStatusBucket} />
            <AreaCardHeader area={area} areaNameHref={areaNameHref} />
        </GaiaExpandableMapMarkerHeader>
    );
}
